import { Phone, Mail, Facebook, MapPin, ChevronUp, MessageCircle } from 'lucide-react';
import { businessInfo } from '../data/mock';

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-zinc-950 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={businessInfo.logo}
                alt="Sound Hire Tarneit"
                className="h-14 w-auto object-contain rounded-lg"
              />
            </div>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-sm mb-6">
              {businessInfo.description}
            </p>
            <div className="flex items-center gap-3">
              <a
                href={businessInfo.contact.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center hover:bg-[#50ced4]/20 hover:border-[#50ced4]/30 border border-transparent transition-all duration-300"
              >
                <Facebook className="w-4 h-4 text-zinc-400" />
              </a>
              <a
                href={`https://wa.me/${businessInfo.contact.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center hover:bg-[#50ced4]/20 hover:border-[#50ced4]/30 border border-transparent transition-all duration-300"
              >
                <MessageCircle className="w-4 h-4 text-zinc-400" />
              </a>
              <a
                href={`mailto:${businessInfo.contact.email}`}
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center hover:bg-[#50ced4]/20 hover:border-[#50ced4]/30 border border-transparent transition-all duration-300"
              >
                <Mail className="w-4 h-4 text-zinc-400" />
              </a>
              <a
                href={`tel:${businessInfo.contact.phones[0].replace(/\s/g, '')}`}
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center hover:bg-[#50ced4]/20 hover:border-[#50ced4]/30 border border-transparent transition-all duration-300"
              >
                <Phone className="w-4 h-4 text-zinc-400" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              {[
                { label: 'Services', href: '#services' },
                { label: 'Packages', href: '#packages' },
                { label: 'Gallery', href: '#gallery' },
                { label: 'FAQ', href: '#faq' },
                { label: 'Contact', href: '#contact' },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-zinc-500 text-sm hover:text-[#50ced4] transition-colors duration-200"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm">
                <Phone className="w-4 h-4 text-[#50ced4] flex-shrink-0" />
                <div>
                  <a href={`tel:${businessInfo.contact.phones[0].replace(/\s/g, '')}`} className="text-zinc-400 hover:text-white transition-colors block">
                    {businessInfo.contact.phones[0]}
                  </a>
                  <a href={`tel:${businessInfo.contact.phones[1].replace(/\s/g, '')}`} className="text-zinc-500 hover:text-white transition-colors block">
                    {businessInfo.contact.phones[1]}
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <Mail className="w-4 h-4 text-[#50ced4] flex-shrink-0" />
                <a href={`mailto:${businessInfo.contact.email}`} className="text-zinc-400 hover:text-white transition-colors">
                  {businessInfo.contact.email}
                </a>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <MessageCircle className="w-4 h-4 text-[#50ced4] flex-shrink-0" />
                <a href={`https://wa.me/${businessInfo.contact.whatsapp}`} target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-white transition-colors">
                  WhatsApp
                </a>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <MapPin className="w-4 h-4 text-[#50ced4] flex-shrink-0" />
                <span className="text-zinc-400">{businessInfo.contact.location}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-zinc-600 text-xs">
            &copy; {new Date().getFullYear()} Sound Hire Tarneit. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-xs text-zinc-600 hover:text-[#50ced4] transition-colors"
          >
            Back to top
            <ChevronUp className="w-3 h-3" />
          </button>
        </div>
      </div>
    </footer>
  );
};
